<template>
  <v-card class="pa-3 ma-0">
    <v-layout row align-center justify-space-between>
      <h2>Mass {{ remove ? 'remove' : 'add' }} Printers</h2>
      <v-btn
        flat
        fab
        small
        type="button"
        class="ma-0"
        data-dismiss="modal"
        @click="$emit('close')"
        aria-label="Close">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
    <v-alert :value="true" type="error" v-if="err">
      {{err}}
    </v-alert>
    <div>
      <v-layout row wrap align-center class="checkbox-wrap my-4">
        <v-checkbox
          v-for="(printer, index) in catalogPrinters"
          :key="index"
          color="primary"
          v-model="printer.selected"
          @change="$forceUpdate()"
          :label="printer.name">
        </v-checkbox>
      </v-layout>
      <v-layout row justify-end>
        <v-btn color="primary" class="mx-0" @click="submitPrinters()">Submit</v-btn>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
  export default {
    props: ['remove'],
    data() {
      return {
        printerCategories: [
          'LABEL',
          'KITCHEN1',
          'KITCHEN2',
          'KITCHEN3',
          'KITCHEN4',
          'KITCHEN5',
          'BAR1',
          'BAR2',
          'BAR3',
          'BAR4',
          'BAR5',
          'SALAD1',
          'SALAD2',
          'SALAD3',
          'SALAD4',
          'SALAD5',
        ],
        language: this.$cookie.get('lang') || 'en',
        catalogPrinters: [],
        err: '',
      };
    },
    methods: {
      submitPrinters() {
        const printers = [];
        this.catalogPrinters.forEach((printer, index) => {
          if (printer.selected) {
            printers.push(printer.name);
          }
        });
        this.$emit('submit', printers);
      },
    },
    created() {
      this.catalogPrinters = this.printerCategories.map((current) => {
        const printer = {
          name: current,
        };
        printer.selected = false;
        return printer;
      });
    }
  };
</script>

<style lang="scss">

  .checkbox-wrap {
    width: 100%;
    .input-group {
      min-width: 140px;
      flex: none;
      width: auto;
      width: fit-content;
      padding: 0 32px;
      .input-group__details {
        display: none !important;
      }
      label {
        position: relative !important;
        left: 0;
        max-width: 220px;
        width: auto;
        width: fit-content;
        overflow: hidden;
      }
      .input-group__input {
        position: absolute;
        left: 0;
        top: 0;
        width: 32px;
        flex: 0;
      }
      --selection-controls {
        display: inline;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// MassPrintersAddModal.vue?7e36c993